import { FC, useCallback } from "react";
import CheckIcon from "../assets/li_check.svg";
import { BaseScreen } from "./BaseScreen";

type ThankYouScreenSumsubProps = {
  sumsubUrl: string;
  embedded: boolean;
};

const ThankYouScreenSumsub: FC<ThankYouScreenSumsubProps> = ({ sumsubUrl, embedded }) => {
  const handleContinue = useCallback(() => {
    if (embedded) {
      window.parent.postMessage(JSON.stringify({ type: "sumsubRedirect", url: sumsubUrl }), "*");
    } else {
      window.location.href = sumsubUrl;
    }
  }, [sumsubUrl, embedded]);

  return (
    <BaseScreen
      formTitle="Application received"
      formSubtitle=""
      headerIcon={CheckIcon}
      footerBtnLabel="Continue"
      footerBtnOnClick={handleContinue}
      footerBtnLoading={false}
      footerBtnDisabled={false}
    >
      <div className="w-full mb-6">
        <p className="text-base leading-6 text-content-secondary">
          {/* TODO: add to translate */}
          Thank you for applying for an account with us. To complete your application, we need to
          verify your identity as part of the Qualified Electronic Signature process, which will take
          place in the next steps. This verification is supported by Sumsub technology, our trusted
          third-party provider.
        </p>
      </div>
    </BaseScreen>
  );
};

export default ThankYouScreenSumsub;
